export function getFlagReviewButtonSx({ selected = false, emphasizeInactive = false } = {}) {
    if (selected) {
        return {
            color: "common.white",
            bgcolor: "warning.dark",
            borderColor: "warning.dark",
            "&:hover": {
                bgcolor: "warning.darker",
                borderColor: "warning.darker",
            },
        }
    }

    if (!emphasizeInactive) {
        return {
            color: "text.primary",
            borderColor: "action.disabled",
            "&:hover": {
                color: "text.primary",
                borderColor: "text.primary",
                bgcolor: "action.hover",
            },
        }
    }

    return {
        color: "warning.dark",
        borderColor: "warning.dark",
        "&:hover": {
            color: "warning.darker",
            borderColor: "warning.darker",
            bgcolor: "warning.lighter",
        },
    }
}
